import type { FC } from 'react';
import React from 'react';

import type {
  AvatarWrapperProps,
  ILoginSocialBarProps,
} from '../../../LoginSocialBar.types';
import { Layout } from '../../../LoginSocialBar.types';
import AvatarWrapper from '../avatar';

import styles from './LoggedOffSocialBar.scss';
import { TEST_ID_HANDLE_BUTTON } from '../../../constants';

type LoggedOffSocialBarProps = Omit<
  AvatarWrapperProps,
  'avatarUri' | 'isLoggedIn' | 'userName'
> &
  Pick<ILoginSocialBarProps, 'translations'> & {
    handleLogin: () => void;
    reportBiOnClick: (label: string) => void;
  };

export const LoggedOffSocialBar: FC<LoggedOffSocialBarProps> = ({
  handleLogin,
  iconSize,
  displayMode,
  id,
  translations,
  reportBiOnClick,
  customAvatar,
  avatarIcon,
}) => {
  const onClick = React.useCallback(() => {
    reportBiOnClick(translations.loggedOutText!);
    handleLogin();
  }, [translations.loggedOutText, handleLogin, reportBiOnClick]);

  const showAvatarOnly = displayMode === Layout.AvatarOnly;
  const showTextOnly = displayMode === Layout.TextOnly;

  return (
    <button
      className={styles.login}
      onClick={onClick}
      data-testid={TEST_ID_HANDLE_BUTTON}
    >
      {!showTextOnly && (
        <AvatarWrapper
          id={id}
          displayMode={displayMode}
          iconSize={iconSize}
          isLoggedIn={false}
          customAvatar={customAvatar}
          avatarIcon={avatarIcon}
        />
      )}
      {!showAvatarOnly && (
        <span className={styles.logOutText}>{translations.loggedOutText}</span>
      )}
    </button>
  );
};
